export default __webpack_public_path__ + "static/media/mute-icon.21c540c0.svg";